import { POST_LOADER_DELAY } from '@/constants';
import { IMaterial } from '@/services/material';
import messages from '../messages';

export default function(context: any) {
  context.$store.commit('loader/ADD', {
    title: 'Creating material',
    promise: context.create().then(
      (material: IMaterial) => {
        context.$router.push({
          name: 'material',
          params: {
            materialId: material.id,
          },
        });
      })
      .catch((error: any) => {
        console.error(error);

        context.$store.commit('dialog/CREATE', {
          title: 'Error :(',
          content: messages.ERROR_MATERIAL_CREATE,
          compact: true,
          delay: POST_LOADER_DELAY,
          buttons: [
            {
              text: 'Close',
              click: (dialog: any) => dialog.close(),
            },
          ],
        });
      }),
    });
}
